import { render, staticRenderFns } from "./WarehouseShelves.vue?vue&type=template&id=56e21040&scoped=true&"
import script from "./WarehouseShelves.vue?vue&type=script&lang=js&"
export * from "./WarehouseShelves.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseShelves.vue?vue&type=style&index=0&id=56e21040&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e21040",
  null
  
)

export default component.exports